// BOM removed
import React from "react";
import { Helmet } from "react-helmet-async";

import HomeHero from "./HomeHero/HomeHero";
import HomeAbout from "./HomeAbout/HomeAbout";
import HomeSlider from "./HomeSlider/HomeSlider";
import PatronTrustee from "./PatronTrustee/PatronTrustee";
import AdvisoryBoard from "./AdvisoryBoard/AdvisoryBoard";
import NewsAndEvent from "./NewsAndEvent/NewsAndEvent";

function Home() {
  return (
    <>
      <Helmet>
              <title>Home | Rajput Shiksha Kosh</title>
              <meta
          name="description"
          content="Welcome to Rajput Shiksha Kosh, your trusted source for educational news and updates."
        />
            </Helmet>

      <div className="home">
        <HomeHero />
        <HomeSlider />
        <HomeAbout />
        <NewsAndEvent />
        <PatronTrustee />
        <AdvisoryBoard />
      </div>
    </>
  );
}

export default Home;
